module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row col-md-12 entrada"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(" Alias ")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "Nombre"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(" Email ")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "Apellido"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(" Email ")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "Email"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row col-md-12 entrada"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(" Compañia ")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "Telefono"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(" Estado ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-radio-group', [_c('el-radio-button', {
    attrs: {
      "label": "prospective"
    }
  }, [_vm._v("Solicitado")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "inactive"
    }
  }, [_vm._v("Inactivo")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "active"
    }
  }, [_vm._v("Activo")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "inactive"
    }
  }, [_vm._v("Rechazado")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "inactive"
    }
  }, [_vm._v("Supendido")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "inactive"
    }
  }, [_vm._v("Sin Acción")])], 1)], 1)]), _vm._v(" "), _vm._m(1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Contacto")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 entrada",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_vm._v("Guardar"), _vm._v(" "), _c('button', {
    staticClass: "btn btn-secondary"
  }, [_vm._v("Cancelar")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0406fdbe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/ContactDetail.vue
// module id = 609
// module chunks = 1